/**
 * @title utility.js: Global sub-module - combination of utility1.js and utility2.js
 * @description A collection of functions used
 * application wide. This module should contain
 * generic utility code. No module specifics.
 * 
 * 07/27/2022
 * utility.js was split into two files, utility1.js and utility2.js
 * utility2.js contains fucntions that are not invoked on Home, Browse 
 * and Product pages. Rest of the functions are in utility1.js
 * 
 * Only utility1.js is imported into new global module called global.hbp.js for Home, Browser & Product (HBP) pages
 * Rest of the site will continue to load existing global.module.js which will inlcude both utility1.js and utility2.js
 */
define(['utility1', 'utility2'], function(util1, util2) {
    let util = Object.assign({}, util1, util2);
    if (typeof window.COSTCO == 'undefined') {
        window.COSTCO = new Object();
    }
    window.COSTCO.util = util;
    return util;
});



// WEBPACK FOOTER //
// ./js/global/utility.js